import ExcelJS from "exceljs";
import { saveAs } from "file-saver";

async function getImageBase64(url) {
  try {
    const response = await fetch(url, { mode: "cors" });
    if (!response.ok) throw new Error(`Failed to fetch image: ${url}`);
    const blob = await response.blob();

    return await new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result.split(",")[1]);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  } catch (err) {
    console.warn("Skipping image due to error:", url, err);
    return null;
  }
}

async function getImageDimensions(url) {
  return new Promise((resolve) => {
    const img = new Image();
    img.onload = () => resolve({ width: img.width, height: img.height });
    img.onerror = () => resolve({ width: 80, height: 80 });
    img.src = url;
  });
}

export const downloadExcelWithImages = async (
  data,
  headers,
  fileName = "Full_Table_Report.xlsx"
) => {
  console.log("Full data coming to Excel download:", data);
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("Report");
  worksheet.addRow(headers.map((h) => h.label));

  for (let i = 0; i < data.length; i++) {
    const row = data[i];
    const rowData = headers.map((h) => {
      if (h.key === "propertiesdetails") {
        return (row.propertiesdetails || [])
          .map((p) => `${p.properties?.name}: ${p.item_property_value}`)
          .join("\n");
      }

      if (h.key === "dimensionsdetails") {
        return (row.dimensionsdetails || [])
          .map((d) => `${d.dimensions?.name}: ${d.item_dimension_value}`)
          .join("\n");
      }
      if (h.key === "file_path") return null;
      const keys = h.key.split(".");
      let value = row;
      for (const k of keys) value = value ? value[k] : "";
      return value ?? "";
    });

    const newRow = worksheet.addRow(rowData);

    newRow.eachCell((cell) => {
      cell.alignment = { wrapText: true, vertical: "top" };
    });

    if (row.file_path) {
      const base64Data = await getImageBase64(row.file_path);
      if (!base64Data) continue;

      const ext = row.file_path.toLowerCase().includes(".jpg") ? "jpeg" : "png";
      const colIndex = headers.findIndex((h) => h.key === "file_path");
      const rowNumber = worksheet.lastRow.number;

      // const dimensions = await getImageDimensions(row.file_path);
      // const maxSize = 80;
      // let { width, height } = dimensions;

      // if (width > height && width > maxSize) {
      //   height = (height / width) * maxSize;
      //   width = maxSize;
      // } else if (height >= width && height > maxSize) {
      //   width = (width / height) * maxSize;
      //   height = maxSize;
      // }

      const TARGET_SIZE = 80; // Adjust to 50 or 40 if needed

      let width = TARGET_SIZE;
      let height = TARGET_SIZE;

      worksheet.getRow(rowNumber).height = TARGET_SIZE / 1.1;
      worksheet.getColumn(colIndex + 1).width = TARGET_SIZE / 5.5;

      const imageId = workbook.addImage({
        base64: base64Data,
        extension: ext,
      });

      worksheet.addImage(imageId, {
        tl: { col: colIndex + 0.2, row: rowNumber - 1 },
        ext: { width, height },
        editAs: "oneCell",
      });
    }
  }

  worksheet.columns.forEach((col) => {
    if (!col.width || col.width < 25) col.width = 25;
  });

  const buf = await workbook.xlsx.writeBuffer();
  saveAs(new Blob([buf]), fileName);
};
